import React from 'react';
import { DollarSign, Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';

export const BulkPayDialog = ({
  open, onOpenChange, count, total, paymentTypes,
  bulkPaymentType, setBulkPaymentType, bulkPaymentComments, setBulkPaymentComments, processing, onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="bulk-pay-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <DollarSign className="h-5 w-5 text-green-600" />
          Mark {count} Invoice{count > 1 ? 's' : ''} as Paid
        </DialogTitle>
        <DialogDescription>Record batch payment for selected invoices</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 pt-2">
        <div className="p-3 bg-gray-50 rounded-lg text-sm">
          <div className="flex justify-between mb-1">
            <span className="text-gray-500">Selected Invoices</span>
            <span className="font-medium">{count}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Total Amount</span>
            <span className="font-bold">${total.toFixed(2)}</span>
          </div>
        </div>

        <div>
          <Label>Payment Type *</Label>
          <Select value={bulkPaymentType} onValueChange={setBulkPaymentType}>
            <SelectTrigger className="mt-1" data-testid="bulk-payment-type-select">
              <SelectValue placeholder="Select payment type" />
            </SelectTrigger>
            <SelectContent>
              {paymentTypes.map(pt => (
                <SelectItem key={pt.value} value={pt.value}>{pt.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label>Comments (optional)</Label>
          <Textarea
            placeholder="e.g., Check #1234, batch payment..."
            rows={2}
            value={bulkPaymentComments}
            onChange={(e) => setBulkPaymentComments(e.target.value)}
            className="mt-1"
          />
        </div>

        <div className="flex gap-2 pt-2">
          <Button variant="outline" className="flex-1" onClick={() => { onOpenChange(false); setBulkPaymentType(''); setBulkPaymentComments(''); }}>
            Cancel
          </Button>
          <Button className="flex-1 bg-green-600 hover:bg-green-700" onClick={onConfirm} disabled={processing || !bulkPaymentType} data-testid="confirm-bulk-pay-btn">
            {processing ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <DollarSign className="h-4 w-4 mr-2" />}
            {processing ? 'Processing...' : 'Mark as Paid'}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
